import { render, staticRenderFns } from "./eventCodeMapping.vue?vue&type=template&id=2bd0fe60"
import script from "./eventCodeMapping.vue?vue&type=script&lang=js"
export * from "./eventCodeMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports